type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object ? DeepPartial<T[P]> : T[P];
};

/**
 * Simple deep merge for style objects.
 * Merges source into target, returning a new object.
 * Arrays are replaced, not merged.
 */
export function deepMerge<T extends Record<string, any>>(
  target: T,
  source: DeepPartial<T> | undefined
): T {
  const result = { ...target }; // Shallow copy to avoid mutating input

  if (!source) return result;

  for (const key in source) {
    if (Object.hasOwn(source, key)) {
      const sourceValue = source[key];
      const targetValue = result[key];

      if (
        sourceValue &&
        typeof sourceValue === 'object' &&
        !Array.isArray(sourceValue) &&
        targetValue &&
        typeof targetValue === 'object' &&
        !Array.isArray(targetValue)
      ) {
        // Recursive merge for objects
        // @ts-ignore
        result[key] = deepMerge(targetValue, sourceValue);
      } else if (sourceValue !== undefined) {
        // Direct assignment for primitives or arrays
        // @ts-ignore - we know this is safe because we're merging partial source into target
        result[key] = sourceValue;
      }
    }
  }

  return result;
}
